import BookmarkPage from "../components/BookmarkPage/BookmarkPage"

export const Bookmark=()=>{
    return <BookmarkPage/>
}